import {combineReducers} from "redux";

import charts from "./charts";
import viewer from "./viewer";
import datasets from "./datasets";

import tooltip from "store/reducers/tooltip";

export default combineReducers({
    charts,
    viewer,
    datasets,
    tooltip
});



// WEBPACK FOOTER //
// ./src/kpi/store/reducers/index.js